// TODO: TEMP PATCH REMOVE AFTER APOLLO CLIENT
import React, { createContext, useReducer } from 'react';
import { fanReducer } from './fanReducer';

const FanStateContext = createContext();
const FanDispatchContext = createContext();

function FanProvider({ children }) {
  const [state, dispatch] = useReducer(fanReducer, {
    fanGenres: [],
  });

  return (
    <FanStateContext.Provider value={state}>
      <FanDispatchContext.Provider value={dispatch}>
        {children}
      </FanDispatchContext.Provider>
    </FanStateContext.Provider>
  );
}

function useFanState() {
  const context = React.useContext(FanStateContext);
  if (context === undefined) {
    throw new Error('useFanState must be used within a FanProvider');
  }
  return context;
}
function useFanDispatch() {
  const context = React.useContext(FanDispatchContext);
  if (context === undefined) {
    throw new Error('useFanDispatch must be used within a FanProvider');
  }
  return context;
}

export { FanProvider, useFanState, useFanDispatch };
